var React = require('react');

function StatusOnHoldInverted (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"On Hold"),React.createElement("g",{"key":1},[React.createElement("path",{"d":"M11.5,0A11.5,11.5,0,1,0,23,11.5,11.51,11.51,0,0,0,11.5,0","style":{"fill":"#fff","fillRule":"evenodd"},"key":0}),React.createElement("path",{"d":"M16.33,10.61H6.67a.89.89,0,0,0,0,1.77h9.66a.88.88,0,0,0,.85-.91.89.89,0,0,0-.85-.86","style":{"fill":"#ff9933","fillRule":"evenodd"},"key":1})])]);
}

StatusOnHoldInverted.defaultProps = {"role":"presentation","viewBox":"0 0 23 23"};

module.exports = StatusOnHoldInverted;

StatusOnHoldInverted.default = StatusOnHoldInverted;
